<div class="bloc">
  <div class="bloc-header">
    <div class="bloc-title">Configuration 1733</div>
  </div>
  <div class="form-grid">
    <div class="form-field">
      <label class="form-label">Token</label>
      <input type="text" class="form-input" placeholder="Saisir le token" [(ngModel)]="form.token"
             (ngModelChange)="onFieldChange()"/>
    </div>
  </div>
</div>
